import { processDroneImages, processVolumesData } from "api/pointCloud";
import fileExplorerConfig from "config/fileExplorerConfig";
import fileUploaderApiConfig from "config/fileUploaderApiConfig";
import projectDateConfig from "config/projectDateConfig";
import { useFileUpload } from "hooks/FilesUploadContext";

const settingsModalConfig = {
  processDroneImages,
  fileUploaderApiConfig,
  fileExplorerConfig,
  projectDateConfig,
  useFileUpload,
  processVolumesData
};

export default settingsModalConfig;